// react imports
import React from 'react';

// react icons imports
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordInput = props => {
  // props
  const { label, name, register, errors, ...rest } = props;

  // states
  const [showPassword, setShowPassword] = React.useState(false);

  // handlers
  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium  dark:text-gray-200"
      >
        {label || 'Password'}
      </label>
      <div className="relative">
        <input
          {...rest}
          {...register(name)}
          type={showPassword ? 'text' : 'password'}
          className={`w-full mt-1 form-input placeholder:text-sm dark:placeholder:text-gray-400 ${
            errors
              ? 'border-red-500 focus:ring-red-500 dark:border-red-600 dark:focus:ring-red-600'
              : ''
          }`}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 mt-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none focus:text-gray-700 dark:focus:text-gray-200 transition-colors duration-200"
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          tabIndex={0}
        >
          {showPassword ? (
            <FaEye className="w-4 h-4" />
          ) : (
            <FaEyeSlash className="w-4 h-4" />
          )}
        </button>
      </div>
      {errors && <p className="mt-2 text-xs text-red-500">{errors}</p>}
    </div>
  );
};

export default PasswordInput;
